import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleBudgetFees } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetFeesComboConfig = () => {
  const { proxy } = getCurrentInstance();

  const store = useStore();

  const budgetFeesCombo = computed(() => {
    const budgetFeess = store.getters[`${ModuleBudgetFees}/items`];
    return budgetFeess.filter(x => !x.inactive);
  });

  // config columns combo
  const cacheBudgetFeesComboConfig = reactive({
    data: budgetFeesCombo,
    columns: [
      {
        title: 'Mã phí, lệ phí',
        dataField: 'budget_fees_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên phí, lệ phí',
        dataField: 'budget_fees_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 450,
      },
    ],
    displayField: 'budget_fees_code',
    valueField: 'budget_fees_id',
    queryMode: 'local',
    dropdownWidth: 600,
    quickSearch: 'LocalQuickSearchPopup',
    quickSearchParam: {
      idField: 'budget_fees_id',
      titleSearch: 'Tìm nhanh phí, lệ phí',
    },
  });

  return {
    cacheBudgetFeesComboConfig,
  };
};
